import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonApp, IonRouterOutlet, isPlatform } from '@ionic/vue';
import { onMounted } from 'vue'
import { useAddToHomescreen } from '@owliehq/vue-addtohomescreen';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted( () => {
  if (!isPlatform('hybrid') && !isPlatform('pwa')) {
    useAddToHomescreen({
      iconPath: '/img/icons/android/android-launchericon-144-144.png',
      title: 'Zainstaluj aplikacje',
      buttonColor: '#D9642C',
      lang: 'pl_PL',
    });
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet))
    ]),
    _: 1
  }))
}
}

})